// src/components/KnowledgeGraph/NodeEditModal.js
import React, { useState } from "react";
import "./KnowledgeGraph.css";

export default function NodeEditModal({ node, onClose, onUpdate, onDelete, onCreate }) {
  // Support both edit (node provided) and create (node is null)
  const isCreateMode      = !node;
  const initialLabel      = isCreateMode ? "" : node.data.label;
  const initialProps      = isCreateMode ? {} : (node.data.properties || {});
  const [label, setLabel] = useState(initialLabel);
  const [errorTypes, setErrorTypes] = useState(initialProps.errorTypes || []);
  const [comments, setComments]     = useState(initialProps.comments || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isCreateMode) {
      onCreate?.({
        label,
        properties: { errorTypes, comments }
      });
    } else {
      onUpdate(node.id, {
        label,
        properties: { errorTypes, comments }
      });
    }
  };

  const handleDelete = () => {
    if (window.confirm("Delete this node and all its relationships?")) {
      onDelete(node.id);
      onClose();
    }
  };

  return (
    <div className="knowledge-graph-modal-overlay">
      <div className="knowledge-graph-modal">
        <header className="knowledge-graph-modal-header">
          <h2>{isCreateMode ? "Add Topic" : `Edit Topic: ${initialLabel}`}</h2>
          <button className="knowledge-graph-modal-close" onClick={onClose}>×</button>
        </header>

        <form onSubmit={handleSubmit}>
          <div className="knowledge-graph-modal-content">
            <label>
              <strong>Topic Name</strong><br/>
              <input
                value={label}
                onChange={e => setLabel(e.target.value)}
                className="knowledge-graph-input"
                required
              />
            </label>

            <label>
              <strong>Error Tags</strong><br/>
              <input
                placeholder="Comma-separate tags"
                value={errorTypes.join(", ")}
                onChange={e => setErrorTypes(e.target.value.split(",").map(s => s.trim()))}
                className="knowledge-graph-input"
              />
            </label>

            <label>
              <strong>Instructor Note</strong><br/>
              <textarea
                rows={3}
                value={comments}
                onChange={e => setComments(e.target.value)}
                className="knowledge-graph-input"
              />
            </label>

            <section>
              <h3>All Other Properties</h3>
              {Object.entries(initialProps).length === 0 && <p>(none)</p>}
              <ul>
                {Object.entries(initialProps).map(([k,v]) => (
                  <li key={k}>
                    <strong>{k}:</strong> {String(v)}
                  </li>
                ))}
              </ul>
            </section>
          </div>

          <footer className="knowledge-graph-modal-footer">
            {!isCreateMode && (
              <button
                type="button"
                className="knowledge-graph-button knowledge-graph-button-danger"
                onClick={handleDelete}
              >
                Delete Node
              </button>
            )}
            <div>
              <button
                type="button"
                className="knowledge-graph-button knowledge-graph-button-outline"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="knowledge-graph-button">
                {isCreateMode ? "Create" : "Save Changes"}
              </button>
            </div>
          </footer>
        </form>
      </div>
    </div>
  );
}
